import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Popconfirm } from 'antd'

interface FormalityStepButtonProps {
  title: string
  description: any
  buttonLabel?: string
  buttonDisabled?: boolean
  buttonType?: 'link' | 'text' | 'ghost' | 'default' | 'primary' | 'dashed'
  danger?: boolean
  onConfirm: any
  onCancel?: any
  okConfirmDisabled?: boolean
  children?: any
}

const FormalityStepButton = (props: FormalityStepButtonProps) => {
  const { t } = useTranslation()
  const {
    title,
    description,
    buttonLabel,
    buttonDisabled = false,
    buttonType,
    danger,
    onConfirm,
    onCancel,
    okConfirmDisabled = false,
  } = props
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)

  const confirmClose = () => {
    setConfirmOpen(false)
    setConfirmLoading(false)
  }

  return (
    <Popconfirm
      title={title}
      cancelText={t('cancel')}
      description={description}
      open={confirmOpen}
      onConfirm={() => {
        onConfirm()
        confirmClose()
      }}
      okButtonProps={{
        loading: confirmLoading,
        disabled: confirmLoading || okConfirmDisabled,
      }}
      onCancel={onCancel || confirmClose}
      placement="topRight"
    >
      {props.children}
      <Button
        onClick={() => setConfirmOpen(true)}
        type={buttonType || 'primary'}
        size="large"
        danger={danger || false}
        disabled={buttonDisabled}
      >
        {buttonLabel || ''}
      </Button>
    </Popconfirm>
  )
}

export default FormalityStepButton
